import { oz } from '@weft/utils';

export const DynamicInvoiceMeterUsageSchema = oz.object({
  totalAmount: oz.number(),
  amountByInstance: oz.record(oz.string(), oz.number()).optional(),
});

export type DynamicInvoiceMeterUsage = oz.infer<typeof DynamicInvoiceMeterUsageSchema>;